import { TemplaCMS } from "./TemplaCMS.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  TemplaCMS
};
//# sourceMappingURL=index.js.map
